import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import Stocks from './components/Stocks/Stocks';
import Customers from './components/Customers/Customers';
import ProtectedRoute from './components/ProtectedRoute';
import authService from './services/authService';
import Sales from '../src/components/Sale/Sale';
import CreateSale from './components/CreateSale/CreateSale';
import Collections from './components/Collections/Collection';
import Settings from './components/Settings/Settings';
import Credit from './components/Credit/Credit';

// 1. Import the Provider
import { PrinterProvider } from './context/PrinterContext';

function App() {
  return (
    // 2. Wrap the entire Router with PrinterProvider 
    // This ensures the Bluetooth connection is held in memory across all pages
    <PrinterProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />

            <Route path="/customers" element={
            <ProtectedRoute>
              <Customers />
            </ProtectedRoute>
          } />

              <Route path="/stocks" element={
            <ProtectedRoute>
              <Stocks />
            </ProtectedRoute>
          } />

          <Route path="/collections" element={
            <ProtectedRoute>
              <Collections />
            </ProtectedRoute>
          } />

           <Route path="/sales" element={
            <ProtectedRoute>
              <Sales />
            </ProtectedRoute>
          } />
          
           <Route path="/create-sale" element={
            <ProtectedRoute>
              <CreateSale />
            </ProtectedRoute>
          } />

           <Route path="/credit" element={
            <ProtectedRoute>
              <Credit />
            </ProtectedRoute>
          } />
            <Route path="/settings" element={
                <ProtectedRoute>
                    <Settings />
                </ProtectedRoute>
            } />
          {/* Root Redirection Logic */}
          <Route path="/" element={
            authService.isAuthenticated() ? 
              <Navigate to="/dashboard" replace /> : 
              <Navigate to="/login" replace />
          } />
          
          {/* Fallback for 404s */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </PrinterProvider>
  );
}


export default App;